module.exports = __webpack_public_path__ + "static/img/91BM-055-BenChan.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-055-BenChan.jpg
// module id = BDyq
// module chunks = 0